/*********************
Ngram Count Rule
*********************/
import Rule from '../Rule';
import { ruleInputTypes, ruleTypes } from '../../../constants';

export default class NgramCountRule extends Rule {
  constructor(logic) {
    super([ruleInputTypes.word_log_ngram_counts],logic);
    this.ruleType = ruleTypes.NGRAM_COUNT;
  }
}